import React, { useContext, useEffect, useState } from "react";
import {
  Box,
  Typography,
  IconButton,
  Button,
  Container,
  Pagination,
  Tooltip,
  Checkbox,
  Divider,
} from "@mui/material";
import SendSharpIcon from "@mui/icons-material/SendSharp";
import CommonAccordion from "../../custom-components/CommonAccordion";
import CommonDownload from "../../custom-components/CommonDownload";
import SaveAltRoundedIcon from "@mui/icons-material/SaveAltRounded";
import ThumbDownIcon from "@mui/icons-material/ThumbDown";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { useLocation, useNavigate } from "react-router-dom";
import CodeEditor from "./CodeEditorForAPITesting";
import { LoadingModalContext } from "../../main-pages/ServicePage";
import ThumbUpOutlinedIcon from "@mui/icons-material/ThumbUpOutlined";
import ThumbDownOutlinedIcon from "@mui/icons-material/ThumbDownOutlined";
import CommonCopy from "../../custom-components/CommonCopy";
import { ReactComponent as GenerateButtonIcon } from "../../../images/generateButton.svg";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import SuccessPopup from "../test-automation/SuccessPopup";
import { use } from "react";



const APIStepDefinition = (props) => {
  //   console.log(props.featureFileData, "featureFile dataaa");
  const location = useLocation();
  // console.log(location, "locationlocationlocation");
  // console.log(props, "propspropspropspropsprops");
  const stepDefinition = props.stepDefinitionData;
  const navigate = useNavigate();
  const isDisabled = true;
  const [pojoClassData, setPojoClassData] = useState(props.pojoData);
  const [zipFile, setZipFile] = useState(props.zipFile);
  const [downloadOpen, setDownloadOpen] = useState(false);
  const setLoading = useContext(LoadingModalContext);
  const [liked, setLiked] = useState(false);
  const [disliked, setDisliked] = useState(false);
  const [openSuccessPopup, setOpenSuccessPopup] = useState(false);
  const [stepDefinitionData, setStepDefinitionData] = useState(
    props.stepDefinitionData
  );
  const [processedStepDefinitionData, setProcessedStepDefinitionData] = useState("");
  useEffect(() => {
    if (props.stepDefinitionData) {
      setStepDefinitionData(props.stepDefinitionData);
    }
  }, [props.stepDefinitionData]);

  const nextButton = !!props.stepDefinitionNextButton ? [props.stepDefinitionNextButton] : [];
  const [activeThumb, setActiveThumb] = useState(null);
  const [isCopied, setIsCopied] = useState(false);
  const [testdata, settestdata] = useState(`
    package test;
    import io.cucumber.testng.AbstractTestNGCucumberTests;
    import io.cucumber.testng.CucumberOptions;
    @CucumberOptions(features = "src/test/resources/features",
                 glue = "gluecode",
                 plugin = {"pretty", "html:target/cucumber-reports.html", "json:target/cucumber.json"},
                 tags = "@smoketest")
    public class TestRunner extends AbstractTestNGCucumberTests
    {  
    }`
  );



  useEffect(() => {
    setStepDefinitionData(props.stepDefinitionData);
  }, [props.stepDefinitionData]);


  const IconComponent = () => (
    <Box sx={{ maxWidth: 14, display: "flex", flexDirection: "column" }}>
      <img
        loading="lazy"
        src="https://cdn.builder.io/api/v1/image/assets/TEMP/74001bbbe35d84ed7dd44adbf23d2273b030df4d38296f54b84768e53b777ae2?placeholderIfAbsent=true&apiKey=61dcb7c26aae4febb0f66efb27027a73"
        alt=""
        style={{ width: "100%", objectFit: "contain" }}
      />
    </Box>
  );
  const handleDownloadClick = () => {
    setDownloadOpen(true);
  };

  const handleCloseDownload = () => {
    setDownloadOpen(false);
  };

  const handleDownload = () => { };
  const handleLike = () => {
    setLiked(!liked);
    if (disliked) setDisliked(false);
  };

  const handleDislike = () => {
    setDisliked(!disliked);
    if (liked) setLiked(false);
  };

  const handleThumbClick = (thumbType) => {
    setActiveThumb((prev) => (prev === thumbType ? null : thumbType));
  };

  const handleGitHubProject = async () => {
    navigate(`/dashboard/api-testing/newProjectGitCredentails`,
      {
        state: { framework: props.framework, projectType: props.projectType,zipFile : props.zipFile},
      });

  }
  useEffect(() => {
    const processed = (() => {
      try {
        if (Array.isArray(stepDefinitionData)) {
          return stepDefinitionData.map(obj => Object.values(obj).join(' ')).join('\n');
        }
        const parsed = JSON.parse(stepDefinitionData);
        if (Array.isArray(parsed)) {
          return parsed.map(obj => Object.values(obj).join(' ')).join('\n');
        }
        return stepDefinitionData; // If not an array, return as-is
      } catch (e) {
        return stepDefinitionData; // Fallback in case of error
      }
    })();

    setProcessedStepDefinitionData(processed);
  }, [stepDefinitionData]);


  return (
    <Box>
      <CommonAccordion
        summary={"Step Definition"}
        details={
          <Box
            sx={{
              backgroundColor: "#fff",
              borderRadius: 1,
              p: 2,
              marginTop: "-15px",
            }}
          >
            <CodeEditor
              // codeContent={stepDefinitionData}
              // setCodeContent={setStepDefinitionData}
              codeContent={
                (() => {
                  try {
                    // If it's an array, join values
                    if (Array.isArray(stepDefinitionData)) {
                      return stepDefinitionData.map(obj => Object.values(obj).join(' ')).join('\n');
                    }

                    // Try to parse string (if it was stored as JSON)
                    const parsed = JSON.parse(stepDefinitionData);
                    if (Array.isArray(parsed)) {
                      return parsed.map(obj => Object.values(obj).join(' ')).join('\n');
                    }

                    // If not parsable or not an array, return as-is
                    return stepDefinitionData;
                  } catch (e) {
                    return stepDefinitionData; // fallback in case of error
                  }
                })()
              }
              setCodeContent={setStepDefinitionData}
            />

            <Container maxWidth={false} disableGutters>
              <Box
                display="flex"
                flexDirection="column"
                alignItems="flex-start"
                justifyContent="flex-start"
                maxWidth="557px"
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    mb: 2,
                    marginTop: 2,
                  }}
                >
                  <Tooltip title="Like" arrow>
                    <Box
                      onClick={() => handleThumbClick("like")}
                      sx={{
                        cursor: "pointer",
                        marginRight: 2, // Margin between the buttons
                        "&:hover": {
                          color: "#49A3FF", // Change color on hover
                        },
                      }}
                    >
                      {activeThumb === "like" ? (
                        <ThumbUpIcon sx={{ fontSize: "24px" }} /> // Filled thumbs up when clicked
                      ) : (
                        <ThumbUpOutlinedIcon sx={{ fontSize: "24px" }} /> // Outlined thumbs up by default
                      )}
                    </Box>
                  </Tooltip>

                  <Tooltip title="Dislike" arrow>
                    <Box
                      onClick={() => handleThumbClick("dislike")}
                      sx={{
                        cursor: "pointer",
                        marginRight: 2, // Margin between the buttons
                        "&:hover": {
                          color: "#FF4842", // Change color on hover
                        },
                      }}
                    >
                      {activeThumb === "dislike" ? (
                        <ThumbDownIcon sx={{ fontSize: "24px" }} /> // Filled thumbs down when clicked
                      ) : (
                        <ThumbDownOutlinedIcon sx={{ fontSize: "24px" }} /> // Outlined thumbs down by default
                      )}
                    </Box>
                  </Tooltip>
                  <CommonCopy contentToCopy={
                    processedStepDefinitionData

                  } />
                </Box>
              </Box>
            </Container>
          </Box>
        }
        buttons={[
          {
            label: "Download",
            onClick: handleDownloadClick,
            variant: "text",
            startIcon: <SaveAltRoundedIcon />,
            sx: { textTransform: "none" },
          },

          ...nextButton,
          {
            label: "Push Project to Git",
            variant: "contained",
            startIcon: <GenerateButtonIcon />,
            sx: { float: "right" },
            onClick: handleGitHubProject,
            disabled: !props.gitHubButton, // Disable if zipBlob is not available
          }
          // {
          //   label: "Generate Maven Project",
          //   // onClick: handleMavenProject,
          //   variant: "contained",
          //   startIcon: <GenerateButtonIcon />,
          //   sx: { textTransform: "none", float: "right" },
          // },
        ]}
        type={"output"}
        fullScreenMode={true}
        defaultExpanded={true}
      />
      <CommonDownload
        open={downloadOpen}
        onClose={handleCloseDownload}
        serviceResponse={[
          {
            heading: "Step Definition",
            type: "text",
            // data: stepDefinitionData.map(obj => Object.values(obj).join(' ')).join('\n'),
            data: processedStepDefinitionData,
          },
        ]}
        serviceName="Step Definition"
        wordData={[
          {
            heading: "Step Definition",
            type: "text",
            //data: stepDefinitionData.map(obj => Object.values(obj).join(' ')).join('\n'),
            data: processedStepDefinitionData,
          },
        ]}
        documents={["docx", "pdf"]}
      />
      <SuccessPopup
        open={props.openSuccessPopup}
        handleClose={() => props.setOpenSuccessPopup(false)}
        // text={"Maven"}
        text={"Maven"}


      />
    </Box>
  );
};

export default APIStepDefinition;
